module.exports = __webpack_public_path__ + "static/media/patient_control.7aa630b0.png";